import React from 'react'
import PropTypes from 'prop-types'

import InventoryAvailabilityTimelines from './InventoryAvailabilityTimelines'
import RequiredCreativeSizes from './RequiredCreativeSizes'

import useStyles from './styles'

const InventoryAvailability = ({ inventory, isOpened, showInventoryTimelines = true }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {showInventoryTimelines && <InventoryAvailabilityTimelines inventory={inventory} />}
      <RequiredCreativeSizes isOpened={isOpened} inventory={inventory} />
    </div>
  )
}

InventoryAvailability.propTypes = {
  inventory: PropTypes.arrayOf(
    PropTypes.shape({
      network_code: PropTypes.number.isRequired,
      placement_id: PropTypes.number,
      ad_unit_id: PropTypes.number,
      name: PropTypes.string.isRequired,
      prices: PropTypes.shape({
        cpm: PropTypes.number,
        cpc: PropTypes.number,
        viewable_cpm: PropTypes.number
      }).isRequired
    })
  ).isRequired,
  isOpened: PropTypes.bool,
  showInventoryTimelines: PropTypes.bool
}

export default InventoryAvailability
